import { Company, CreateCompanyReq } from "../types/companyTypes";
import { $Service } from "./Service";

export default class CompanyService extends $Service {
  public getCompaniesByUser(): Promise<Company[]> {
    return this.client.get("/companies");
  }

  public createCompany(req: CreateCompanyReq): Promise<Company> {
    return this.client.post("/companies", req);
  }
}
